import styled from 'styled-components'
import { useModuleContext } from '../contexts/module'
import useControls from '../hooks/useControls'
import { Icon } from '@mch-group/uikit-components'
import horizontalGalleryBreakpoint from '../constants/horizontal-gallery-breakpoint'

/**
 * @returns {JSX.Element}
 * @constructor
 */
/** This should be feasible with UIKIT (using TextLink), but it's not enough flexible. */
const SeeArtworkVideo = ({ label }) => {
  /** Video is always last, so number of images === index position of video in array of "artworks" **/
  /** Clarifying comment in line above, Video is not "always last" anymore */
  const { state: { artworkInformation } } = useModuleContext()
  const { numberOfImages } = artworkInformation || {}
  const { handleDotClick } = useControls()

  const handleClick = () => {
    /** If its mobile we also want to go back to top where the video is **/
    if (typeof window !== 'undefined' && typeof window.scrollTo === 'function' &&
      window.innerWidth <= horizontalGalleryBreakpoint) {
      window.scrollTo({ top: 0 })
    }
    handleDotClick(numberOfImages)
  }

  return (
    <div className='mb-4'>
      <AnchorStyled onClick={handleClick}>
        <Icon name='play' className='me-3' />
        <span className='text-link align-bottom'>{label}</span>
      </AnchorStyled>
    </div>
  )
}

const AnchorStyled = styled.a`
  cursor: pointer;
`

export default SeeArtworkVideo